module.exports = __webpack_public_path__ + "static/img/01_stethoscope_cornelius_carstens.7654a35.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/projects/stethoscope/01_stethoscope_cornelius_carstens.gif
// module id = GwxV
// module chunks = 1